import { AppointmentStateEnum } from '@/gql/myomr'

import { useMeetingsBase } from './useMeetingsBase'

export { type AppointmentNode } from './useMeetingsBase'

export function useMeetingsDeclined() {
  return useMeetingsBase([AppointmentStateEnum.Denied, AppointmentStateEnum.Cancelled, AppointmentStateEnum.DeclinedAuto])
}
